module.exports = __webpack_public_path__ + "static/media/TITAN.1682711b.svg";